<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="page_1"></a>YOUR TOWNS &amp; CITIES IN WORLD WAR TWO</p>
<div class="img_container1">
<img alt="images" src="images/border.jpg"/>
</div>
<p class="half">DARLINGTON</p>
<p class="half1">AND</p>
<p class="half1">TEESDALE</p>
<p class="sub">AT WAR <span class="year">1939–45</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?60c4929c